import type { FC } from 'react';
import { type TabPaneProps, Tabs, type TabsProps } from 'antd';

import { ReactComponent as MoreIcon } from '../../../assets/icons/tab-more.svg';

interface TabProps
  extends Pick<
    TabsProps,
    | 'onChange'
    | 'defaultActiveKey'
    | 'activeKey'
    | 'className'
    | 'destroyOnHidden'
    | 'tabBarExtraContent'
    | 'tabBarGutter'
  > {
  contents: {
    title: string;
    content: TabPaneProps['children'];
    contentKey: string;
  }[];
}

const Tab: FC<TabProps> = ({
  contents,
  defaultActiveKey = '1',
  onChange = () => {},
  activeKey,
  className,
  destroyOnHidden = false,
  tabBarExtraContent = false,
  tabBarGutter,
}) => {
  return (
    <Tabs
      destroyOnHidden={destroyOnHidden}
      moreIcon={<MoreIcon />}
      defaultActiveKey={defaultActiveKey}
      activeKey={activeKey}
      className={className ? className : 'common-tabs'}
      onChange={onChange}
      tabBarExtraContent={tabBarExtraContent}
      tabBarGutter={tabBarGutter}
      items={contents?.map(({ title, content, contentKey }, key) => ({
        children: content,
        key: contentKey ?? String(key + 1),
        label: <label className="tab-title cursor-pointer">{title}</label>,
      }))}
    />
  );
};

export default Tab;
